export function resolveNavGridLoadPolicy(options = {}, online = true) {
  const localOnly = options?.localOnly === true || online === false;
  return {
    localOnly,
    waitForCloud: !localOnly && options?.waitForCloud !== false,
  };
}
